// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthHeading_container__G55FB","description":"AuthHeading_description__Dnsrg"};